import {useState} from 'react';
import useShow from '../../../hooks/useShow';
import {SubscriptionPlan} from '../../../redux/subscription/subscription.type';

export function usePlanPopupHandlers() {
    const detailsPopShow = useShow();
    const assigningEventsShow = useShow();
    const [selectedPlan, setSelectedPlan] = useState<SubscriptionPlan | null>(null);

    const handleOpenDetails = (plan: SubscriptionPlan) => {
        setSelectedPlan(plan);
        detailsPopShow.open();
    };
    
    const handleOpenAssigningEvents = (plan: SubscriptionPlan) => {
        setSelectedPlan(plan);
        assigningEventsShow.open();
    };
    
    const handleCloseDetails = () => {
        detailsPopShow.close();
        setSelectedPlan(null);
    };
    
    const handleCloseAssigningEvents = () => {
        assigningEventsShow.close();
        setSelectedPlan(null);
    };
    
    return {
        handleOpenDetails,
        handleOpenAssigningEvents,
        detailsPopShow,
        assigningEventsShow,
        selectedPlan,
        handleCloseDetails,
        handleCloseAssigningEvents,
    };
}

